import type { AssignmentCard, AssignmentListItem } from '@/types/api';
import { formatRelative } from '@/lib/format';

type Props = {
  assignment: AssignmentCard | AssignmentListItem;
  onClick?: () => void;
};

function title(a: AssignmentCard | AssignmentListItem): string {
  if ('practice_title' in a) return a.practice_title;
  return a.practice_seed?.title ?? '(untitled)';
}

function teacher(a: AssignmentCard | AssignmentListItem): string {
  if ('teacher_name' in a) return a.teacher_name;
  return '';
}

export function AssignmentRow({ assignment, onClick }: Props) {
  return (
    <button
      type="button"
      onClick={onClick}
      className="flex w-full flex-col gap-1 rounded-xl bg-[var(--color-secondary-bg)] px-4 py-3 text-left transition-opacity active:opacity-70"
    >
      <div className="flex items-center justify-between">
        <span className="font-medium text-[var(--color-fg)]">{title(assignment)}</span>
        <span className="text-xs text-[var(--color-muted)]">
          {formatRelative(assignment.assigned_at)}
        </span>
      </div>
      <div className="flex items-center gap-2 text-xs text-[var(--color-muted)]">
        {teacher(assignment) ? <span>{teacher(assignment)}</span> : null}
        {assignment.due_date ? (
          <>
            <span>·</span>
            <span>due {formatRelative(assignment.due_date)}</span>
          </>
        ) : null}
      </div>
    </button>
  );
}
